import { createContext, useContext } from 'react';

import type { FormId } from '../fixtures/domain.js';

/** Where a form lives: its page in Forms, on its questions or on one
 *  jobseeker's answers. Absent where there is no such page to go to. */
export interface ResponseLink {
  /** Whether the form is still in the library, so its page exists. */
  opens: (formId: FormId) => boolean;
  open: (formId: FormId, responseId: string) => void;
  openForm: (formId: FormId) => void;
}

export const ResponseLinkContext = createContext<ResponseLink | null>(null);

export function useResponseLink(): ResponseLink | null {
  return useContext(ResponseLinkContext);
}
